import { getCookieAgreement } from '@src/utils/cookieConsent';
import { isDotCom } from '@src/site';
import { initYaMetrika, reachGoalYaMetrika } from '@src/utils/metrika';

export function initAnalytics(): void {
  if (isDotCom() || !getCookieAgreement() || !['santa-secret.ru', 'www.santa-secret.ru'].includes(window.location.hostname)) {
    return;
  }
  // Same production counter as santa-frontend/postbuild.js; previews stay untracked.
  window.ymID ??= 50179975;
  initYaMetrika();
}

export function trackEvent(event: string, data?: Record<string, unknown>): void {
  if (isDotCom() || !getCookieAgreement() || !['santa-secret.ru', 'www.santa-secret.ru'].includes(window.location.hostname)) {
    return;
  }
  reachGoalYaMetrika(event, data);
}
